import { render, staticRenderFns } from "./BucketKPIs.vue?vue&type=template&id=4203bb06"
import script from "./BucketKPIs.vue?vue&type=script&lang=js"
export * from "./BucketKPIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports